import { useI18n } from 'vue-i18n'

export const translations = {
  'pt-br': {
    StagingActivationTitle: 'Ambiente de staging',
    StagingActivationBody: 'Ative esta conta permanentemente para não perder o acesso quando o período de teste expirar.',
    StagingActivationAction: 'Ativar conta permanentemente',
    StagingActivationSuccess: 'Conta ativada permanentemente neste ambiente de staging.',
    StagingActivationError: 'Não foi possível ativar a conta. Tente novamente.'
  }
}

export const useStagingAccountActivationTranslation = () => useI18n({ messages: translations })
